import { Component } from '@angular/core';

@Component({
    selector: 'tun-main-player',
    templateUrl: './main-player.component.html',
    styleUrls: ['./main-player.component.scss'],
    standalone: false
})
export class MainPlayerComponent {

}
